import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-access-deny-user',
    imports: [CommonModule],
    templateUrl: './access-deny-user.component.html',
    styleUrl: './access-deny-user.component.less'
})
export class AccessDenyUserComponent {
  userValidationMessage: string = 'Access Denied';

  constructor() {}

  goBack(): void {
    window.location.href = '/';
  }
}
